/* Built In Imports */
import moment from 'moment-timezone';
import dynamic from 'next/dynamic';
import { useRouter } from 'next/router';
import { useEffect, useState } from 'react';

/* External Imports */
import { Box, Image, Heading } from '@chakra-ui/react';
import { render } from 'datocms-structured-text-to-html-string';
import StructuredTextContent from '@components/UI/StructuredTextContent';
import StructuredTextParser from '@components/Utility/ArticleParser/StructuredTextParser13';
/**
 *
 * @param sectionContent
 * @param region
 * @param lang
 */

const TopBannerSM = ({ sectionContent, region, lang, csrData, currentRegion }) => {
  const [timezone, setTimezone] = useState(null);
  const router = useRouter();
  const others = router.asPath;
  //Check if page is PBK online
  const  sadhguruishaDigital = router.asPath.includes(
    'sadhguru-isha-digital-handles'
  );
  return (
     <Box
      height="100%"
      w="100%"
      maxW={1330}
      mx="auto"
      id="top-header"
     >
    <Box
        maxW={1330}
        w="100%"
        mx="auto"
        pos="relative"
    >
        <Box
          alignItems={'center'}
          display={'flex'}
          backgroundRepeat="no-repeat"
          backgroundSize={{ base: 'cover', sm: 'cover' }}
          backgroundPosition={{
            base: 'center 0',
            sm: 'center 0',
            md:  '',
            lg: 'top center',
            xl: 'center',
          }}
          backgroundImage={{
            md: sectionContent?.desktopImage?.url,
            base:
              sectionContent?.mobileImage?.url ||
              sectionContent?.desktopImage?.url,
          }}
          mb={{ base: '0', xl: '0' }}
          height={"201px"}
        >
          <Box 
          maxW={450} 
          w={{base:'90%', md:'100%'}} 
          margin={"auto"}
          >
            {/* Heading of the banner */}
            {sectionContent?.title && sectionContent?.title.length && (
              <Heading
                as="h1"
                fontSize= {'37px'}
                color="#FFF"
                fontFamily="FedraSansStd-A-medium,serif"
                fontStyle="normal"
                fontWeight="400"
                lineHeight={"130%"}
                w={{base:'100%',md:'100%'}}
                textAlign={"center"}s
              >
                {sectionContent?.title}
              </Heading>
            )}

            {/* description of the banner */}
            {sectionContent?.titleSubtext && (
              <Box>
                <StructuredTextParser
                  maxWidth={361}
                  mt="0"
                  color="#FFCBA0"
                  fontFamily="FedraSansStd-book, sans-serif"
                  fontSize={{ base: '20px', md: '28px' }}
                  fontStyle="normal"
                  fontWeight="400"
                  mb="0"
                  lineHeight={{ base: '28px', md: '128%' }}
                  str={render(sectionContent?.titleSubtext)}
                  className={'sub-text'}
                />
              </Box>
            )}
          </Box>
        </Box>
      </Box>
    </Box>
  );
};
export default TopBannerSM;
